import React, { Suspense } from "react";
import { Navigate } from "react-router-dom";
import FallBackUI from "../FallBackUI";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = JSON.parse(localStorage.getItem("isLoggedIn"));

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return <Suspense fallback={<FallBackUI />}>{children}</Suspense>;
};

export default ProtectedRoute;
